import { Check, Minus, X } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const columns = ["Immobilien", "Photovoltaik", "Kunst & Alternatives", "Geldvermögen"];

const rows = [
  { label: "Steuerliche Abschreibung", values: [{ s: 1, c: "AfA & Sonder-AfA" }, { s: 1, c: "IAB & Sonder-AfA" }, { s: 0, c: "Über Haltefrist" }, { s: -1, c: "" }] },
  { label: "Inflationsschutz", values: [{ s: 1, c: "" }, { s: 1, c: "" }, { s: 1, c: "" }, { s: -1, c: "" }] },
  { label: "Staatliche Absicherung", values: [{ s: 0, c: "Indirekt" }, { s: 1, c: "EEG, 20 Jahre" }, { s: -1, c: "" }, { s: -1, c: "" }] },
  { label: "Krisenresistenz", values: [{ s: 1, c: "" }, { s: 1, c: "" }, { s: 1, c: "" }, { s: 0, c: "Begrenzt" }] },
  { label: "Börsenunabhängigkeit", values: [{ s: 1, c: "" }, { s: 1, c: "" }, { s: 1, c: "" }, { s: -1, c: "" }] },
];

const Cell = ({ v }) => (
  <div className="flex flex-col items-center gap-1.5 py-1">
    {v.s === 1 && <Check size={18} className="text-forest" />}
    {v.s === 0 && <Minus size={18} className="text-gold" />}
    {v.s === -1 && <X size={18} className="text-slate-300" />}
    {v.c && <span className="font-mono text-[10px] uppercase tracking-wider text-slate-400 text-center">{v.c}</span>}
  </div>
);

export const Comparison = () => (
  <section id="vergleich" data-testid="comparison-matrix" className="bg-white py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <Reveal>
        <p className="eyebrow mb-4">Der Vergleich</p>
        <h2 className="max-w-3xl font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-petrol">
          Sachwert schlägt Geldwert — auf einen Blick
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600">
          Drei Anlageklassen, ein Ziel: Vermögen steueroptimiert und
          krisenresistent strukturieren — im Gegensatz zum klassischen
          Geldvermögen.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-14 overflow-x-auto" data-testid="comparison-table-wrap">
          <table className="w-full min-w-[720px] border-collapse" data-testid="comparison-table">
            <thead>
              <tr className="border-b-2 border-petrol">
                <th className="py-5 pr-4 text-left font-mono text-xs uppercase tracking-[0.2em] text-slate-500 w-1/5">Kriterium</th>
                {columns.map((c, i) => (
                  <th
                    key={c}
                    className={`px-4 py-5 text-center font-display text-base sm:text-lg font-semibold ${i === 3 ? "text-slate-400" : "text-petrol"}`}
                    data-testid={`comparison-col-${i}`}
                  >
                    {c}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, ri) => (
                <tr key={r.label} className="border-b border-petrol/10 transition-colors duration-200 hover:bg-mist/60" data-testid={`comparison-row-${ri}`}>
                  <td className="py-5 pr-4 text-sm font-semibold text-slate-700">{r.label}</td>
                  {r.values.map((v, vi) => (
                    <td key={vi} className="px-4 py-5 text-center align-top">
                      <Cell v={v} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">
          Vereinfachte Darstellung — ersetzt keine individuelle Steuer- oder Anlageberatung.
        </p>
      </Reveal>
    </div>
  </section>
);
